import React from 'react';
import { Box } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import VehicleDetailsForm from '../Components/VehicleDetailsForm';

const AddVehiclePage = () => {
  const location = useLocation();
  const state = location.state || {};

  return (
    <Box bg="gray.50" minH="100vh">
      <VehicleDetailsForm 
        isOpen
        mode="page"
        vehicleToEdit={state.vehicleToEdit || null}
        storedMedia={state.storedMedia}
      />
    </Box>
  );
};

export default AddVehiclePage;

